import { createStyles } from "@mantine/core";
import { getTypographyStyles } from "src/theme/themeConfig";

const useStyles = createStyles((theme) => {
  const { colors } = theme.other;
  return {
    contentContainer: {
      padding: '20px',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      overflowY: 'auto',
      paddingTop: '0',
    },
    formWrapper: {
      display: 'flex',
      flexDirection: 'column',
      marginTop: '-12px',
      gap: '16px',
      // eslint-disable-next-line max-len
      '& .mantine-Select-input, .mantine-DatePicker-input, .mantine-TextInput-input, .mantine-NumberInput-input , .mantine-DateInput-input , .mantine-Input-input  ': {
        borderRadius: '4px',
        height: '44px',
        border: `1px solid ${colors.disabled.muted}`,
        backgroundColor: colors.bg.default,
        ...getTypographyStyles('content_sm_regular'),
        '&[data-with-icon]': {
          paddingLeft: '48px',
        },
      },
      '.mantine-Button-root': {
        height: '45px',
        border: 'none',
        borderRadius: '8px',
        width: '100%',
        padding: '12px 24px',
        color: '#ffffff',
        fontSize: '16px',
        fontWeight: 500,
      },
      '& .mantine-Select-item': {
        border: 'none',
        width: '100%',
        padding: '12px 24px',
        ...getTypographyStyles('content_sm_regular'),
      },
      '& .mantine-NumberInput-control': {
        borderColor: colors.disabled.muted,
      },
    },
  }
});

export default useStyles;
